module.exports = __webpack_public_path__ + "static/media/rounds_back_1_4.47f2f384.svg";